
function Book() {
  return (
    <text>Bookdayo</text>
  );
}

export default Book;
